import React from 'react';
import {oauthLogout} from 'hooks/useAuthTokens';

export default function NoUserFound(){

  return (
      <div className="page not-found-page">
        <h1>Cannot Retrieve Identity</h1>
        <button className='logout' onClick={oauthLogout}>Logout</button>
      </div>
  );
}